import { css } from "styled-components";
import { styled, blurBehindMixin, rippleMixin } from "../../../styled-components";

export const TabLabelStyle = styled.div<{ isTablet: boolean }>`
    margin-top: -1px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    width: 100%;

    margin-left: ${p => (p.isTablet ? 6 : 0)}px;

    ${p => (p.isTablet ? p.theme.tabBar.tab.tablet.fontStyle : p.theme.tabBar.tab.phone.fontStyle)}
    color: inherit;
`;

export const TabBarStyle = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 10;
    .builder & {
        position: absolute;
    }
    .player & {
        position: fixed;
    }

    height: calc(${p => p.theme.tabBar.height}px + var(--safe-area-inset-bottom));

    &.desktop {
        top: 0;
        bottom: unset;
        z-index: 50;
        height: ${p => p.theme.tabBar.height}px;

        box-shadow: 0 1px 0px 0px rgba(0, 0, 0, 0.2);

        .tbs-inner {
            justify-content: flex-start;
        }
    }

    bottom: 0;
    right: 0;
    left: 0;
    background-color: ${p => p.theme.primaryOverlayColor};
    box-shadow: 0 -1px 0px 0px rgba(0, 0, 0, 0.2);

    ${p => blurBehindMixin({ backgroundColor: p.theme.transparentOverlayColor })}

    & .tbs-inner {
        display: flex;
        width: 100%;
        max-width: 1366px;
        justify-content: flex-start;
    }

    &.tablet .tbs-inner {
        justify-content: space-around;
        padding-left: 65px;
        padding-right: 65px;
    }

    &.hidden {
        opacity: 0;

        height: var(--safe-area-inset-bottom);
    }

    &.desktop.hidden {
        opacity: 0;

        height: 0;
    }

    transition: transform 0.2s, height 0.2s, opacity 0.2s;
`;

interface TabStyleProps {
    selected: boolean;
    highlightedSelectMode: boolean;
    focused: boolean;
}

export const TabStyle = styled.button<TabStyleProps>`
    position: relative;

    transition: height 250ms ease-in-out;
    height: ${p => p.theme.tabBar.height}px;

    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;

    /* A little insane but a flex basis of 0 for Nexus 7 in browser results in a zero width.
    "auto" will allow the tab to show */
    flex-basis: 1;
    flex-grow: 1;
    flex-shrink: 0;

    border: 1px solid transparent;
    padding: 0px;
    margin: 0;

    text-align: center;
    ${p => p.theme.fontStyles.Header7}
    color: ${p => (p.selected ? p.theme.primaryAccentColor : p.theme.tabBar.unselectedColor)};
    border-radius: 10px;
    &:hover {
        cursor: pointer;

        ${p =>
            p.highlightedSelectMode
                ? css`
                      ::after {
                          content: "";
                          position: absolute;
                          width: 100%;
                          height: 100%;
                          border: 2px solid #2b5fe088;
                          border-radius: 0;
                      }
                  `
                : ""};
    }

    ${TabLabelStyle} {
        display: ${p => (p.theme.showTabLabels ? "block" : "none")};
        margin-top: 4px;
    }

    .tablet &,
    .desktop & {
        justify-content: center;

        /* A little insane but a flex basis of 0 for Nexus 7 in browser results in a zero width.
        "auto" will allow the tab to show */
        flex-basis: auto;
        flex-grow: 0;

        padding: 0 24px;

        ${TabLabelStyle} {
            margin-top: 0px;
        }
    }

    ${p => p.theme.navBar.style === "Android" && rippleMixin}

    ${p =>
        p.highlightedSelectMode && p.selected && p.focused
            ? css`
                  ::after {
                      content: "";
                      position: absolute;
                      width: 100%;
                      height: 100%;
                      border: 1px solid #2b5fe0 !important;
                      border-radius: 0;
                  }
              `
            : ""};
`;

export const ButtonContent = styled.div<{ isTablet: boolean }>`
    position: ${p => (p.isTablet ? "static" : "absolute")};
    width: 100%;
    height: 100%;

    display: flex;
    flex-direction: ${p => (p.isTablet ? "row" : "column")};
    justify-content: center;
    align-items: center;
    text-align: ${p => (p.isTablet ? "left" : "center")};

    padding-top: ${p => (p.isTablet ? 0 : 4)}px;
`;
